import type { DialogProps } from "@mui/material";


export const programmaticSetValueOptions = {
  shouldDirty: false,
} as const;

export function requestCloseWithUnsavedCheck(
  isDirty: boolean,
  onClose: () => void,
  onConfirmDiscard: () => void
): void {
  if (isDirty) {
    onConfirmDiscard();
  } else {
    onClose();
  }
}

export function createDiscardOnDialogCloseHandler(
  isDirty: boolean,
  onClose: () => void,
  onConfirmDiscard: () => void
): NonNullable<DialogProps["onClose"]> {
  return (_event, reason) => {
    if (reason === "backdropClick" || reason === "escapeKeyDown") {
      requestCloseWithUnsavedCheck(isDirty, onClose, onConfirmDiscard);
    } else {
      onClose();
    }
  };
}
